import LayerAdminService from "./LayerAdminService";

export default class OsmPoiService extends LayerAdminService {
  public async Force(source: string): Promise<any> {
    return this._client
      .post<any>(`${this._endpoint}/OSM:POI`, source, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data;
      });
  }
  public async Defer(source: string): Promise<any> {
    return this._client
      .post<any>(`${this._endpoint}/OSM:POI/defer`, source, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data;
      });
    }
}
